import { timescaleToTimePeriodBreakdownMap } from '../constants.tsx';
import { isCustomTimeScale } from '../summary/main.tsx';
import { REPORT_DEFAULTS } from './constants.tsx';
import type { RouterProps, TimescaleQueryParam } from './types.tsx';

export const getReportsQueryParams = (
	routerProps: RouterProps,
	defaultQuery?: TimescaleQueryParam,
): TimescaleQueryParam => {
	const timescaleId =
		Number(routerProps.timescaleId) ||
		Number(defaultQuery && defaultQuery.timescaleId) ||
		Number(REPORT_DEFAULTS.searchByPastSevenDays);

	if (isCustomTimeScale(timescaleId)) {
		const { startDate, endDate, timeBreakdown } = routerProps;
		if (startDate !== undefined && endDate !== undefined) {
			return {
				reportId: routerProps.reportId,
				timescaleId,
				startDate,
				endDate,
				timeBreakdown: timeBreakdown || REPORT_DEFAULTS.timeBreakdown,
			};
		}
		if (defaultQuery !== undefined) {
			return { ...defaultQuery, reportId: routerProps.reportId };
		}
	}
	return {
		reportId: routerProps.reportId,
		// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type '{ readonly 1: { readonly timeBreakdown: "h"; readonly timePeriod: "PT48H"; }; readonly 2: { readonly timeBreakdown: "d"; readonly timePeriod: "P7D"; }; readonly 3: { readonly timeBreakdown: "d"; readonly timePeriod: "P14D"; }; ... 4 more ...; readonly 8: { ...; }; }'.
		...timescaleToTimePeriodBreakdownMap[timescaleId],
		timescaleId,
	};
};
